import React from 'react'
import PropTypes from 'prop-types'

const PropsTable = ({ value, renderLabel, renderValue, emptyMessage }) => {
  if (!value || !Object.keys(value).length) {
    return (
      <table className='opal-presentation-table zebra-rows separated-rows table-border'>
        <tbody className='opt-tbody'>
          <tr className='opt-tr'>
            <td className='opt-td text-center opacity-lowlighted'>
              {emptyMessage || 'No definition available'}
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <table className='opal-presentation-table zebra-rows separated-rows table-border'>
      <tbody className='opt-tbody'>
        {Object.entries(value).map(([key, val]) => (
          <tr key={key} className='opt-tr'>
            <td className='opt-td' style={{ width: '100px' }}>
              {renderLabel ? renderLabel(key, val) : key}
            </td>
            <td className='opt-td'>
              {renderValue ? renderValue(key, val) : String(val)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

PropsTable.propTypes = {
  value: PropTypes.object,
  renderLabel: PropTypes.func,
  renderValue: PropTypes.func,
  emptyMessage: PropTypes.string
}

export default PropsTable
